import React from 'react';
import { Routes, Route } from 'react-router-dom';
import StatusesPage from './pages/StatusesPage';

function Statuses() {
  return (
    <Routes>
      <Route path="/" element={<StatusesPage />} />
    </Routes>
  );
}

export default Statuses;